// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2BYYQ","ButtonWhite":"Button_ButtonWhite__2J13y","ButtonPrimary":"Button_ButtonPrimary__10Qqe"};